import React, { useContext, useMemo } from "react";

import "./EUMRVPortStays.scss";

import CustomTable from "../../../../../../common/customTable/CustomTable";
import {
	DerogationPhaseInColumns,
	EUMRV_PORTSTAYS_HEADERS,
	ETS_COLUMN_KEYS,
	MRV_COLUMN_KEYS
} from "../../../../../../constants/CustomTableHeaders";
import { ClaimsContext } from "../../../../../../services/ClaimsService";
import { FeatureType } from "../../../../../../constants/FeatureToggles";

const DerogationPhaseIn = ({ data }) => {
	const { userHasFeature } = useContext(ClaimsContext) || {};
	

	const columnsData = useMemo(() => {	
        const idsToExclude =   MRV_COLUMN_KEYS;
		return DerogationPhaseInColumns.filter((col) => !idsToExclude.includes(col.accessorKey));
	}, []);

	return (
		<div className="mt-4 eu_mrv_ps">
			<CustomTable
				columnsData={columnsData}
				renderTableData={data || []}
				customProps={{
					header: EUMRV_PORTSTAYS_HEADERS.PHASE_IN,
					enableSort: false,
					tableName: "emissions-report",
					maxHeight: "30vh",
				}}
			/>
		</div>
	);
};

export default DerogationPhaseIn;
